import React from 'react';
import ModuleGate from '../../components/ModuleGate';
import DPRWorkspace from '../dpr/DPRWorkspace';

export default function DPRPage() {
  const token = localStorage.getItem('token');
  return (
    <ModuleGate moduleKey="dpr_workspace" moduleName="DPR / Project Report" token={token}>
      <DPRWorkspace />
    </ModuleGate>
  );
}
